var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardsMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit-cards_mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formato-Cot-Copy-2",
    transform: "translate(-696.000000, -367.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit_card",
    transform: "translate(128.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(568.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,0 L28.75,0 C29.4375,0 30,0.529411765 30,1.17647059 L30,18.8235294 C30,19.4705882 29.4375,20 28.75,20 L1.25,20 C0.5625,20 0,19.4705882 0,18.8235294 L0,1.17647059 C0,0.529411765 0.5625,0 1.25,0 Z",
    id: "Shape",
    fill: "#4361C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.59375,6.25 C21.09375,6.25 23.125,8.28125 23.125,10.78125 C23.125,13.28125 21.09375,15.3125 18.59375,15.3125 C16.09375,15.3125 14.0625,13.28125 14.0625,10.78125 C14.0625,8.28125 16.09375,6.25 18.59375,6.25 Z",
    id: "Shape",
    fill: "#FFAF38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#FFAF38",
    points: "14.6875 8.4375 17.8125 8.4375 17.8125 9.0625 14.6875 9.0625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.40625,15.3125 C8.90625,15.3125 6.875,13.28125 6.875,10.78125 C6.875,8.28125 8.90625,6.25 11.40625,6.25 C13.90625,6.25 15.9375,8.28125 15.9375,10.78125 C15.9375,13.28125 13.90625,15.3125 11.40625,15.3125 Z",
    id: "Shape",
    fill: "#EB3636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6875,12.8125 L14.6875,12.1875 L18.75,12.1875 L18.75,12.8125 L14.6875,12.8125 Z M14.6875,8.4375 L18.75,8.4375 L18.75,9.0625 L14.6875,9.0625 L14.6875,8.4375 Z M18.4375,10.3125 L14.375,10.3125 L14.375,9.6875 L18.4375,9.6875 L18.4375,10.3125 Z M18.4375,11.5625 L14.375,11.5625 L14.375,10.9375 L18.4375,10.9375 L18.4375,11.5625 Z",
    id: "Shape",
    fill: "#FFAF38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25,20 L1.8125,20 L30,1.70588235 L30,1.17647059 C30,0.529411765 29.4375,0 28.75,0 L1.25,0 C0.5625,0 -5.32907052e-15,0.529411765 -5.32907052e-15,1.17647059 L-5.32907052e-15,18.8235294 C-5.32907052e-15,19.4705882 0.5625,20 1.25,20 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.05
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardsMastercard);
export default __webpack_public_path__ + "static/media/credit-cards_mastercard.10bbe6254a96ff8b0d2ce14a9a99104a.svg";
export { ForwardRef as ReactComponent };